<div class="ai-config">
  <h3 class="ai-config__title">{{ 'organization_unit.ai_config.title' | translate }}</h3>
  <p class="ai-config__description">{{ 'organization_unit.ai_config.description' | translate }}</p>

  @if (loading) {
    <mat-spinner diameter="24"></mat-spinner>
  } @else {
    <div class="ai-config__column">
      <div class="ai-config__toggle">
        <mat-checkbox color="primary" [checked]="aiEnabled" (change)="toggleAiEnabled($event.checked)">
          {{ 'organization_unit.ai_config.enabled.label' | translate }}
        </mat-checkbox>
        <p class="ai-config__hint">{{ 'organization_unit.ai_config.enabled.hint' | translate }}</p>
      </div>

      <mat-form-field appearance="outline" class="ai-config__field">
        <mat-label>{{ 'organization_unit.ai_config.token_limit.label' | translate }}</mat-label>
        <input matInput type="number" min="1" step="1" [formControl]="tokenLimitControl" />
        @if (tokenLimitControl.hasError('required') || tokenLimitControl.hasError('min') || tokenLimitControl.hasError('integer')) {
          <mat-error>{{ 'organization_unit.ai_config.token_limit.invalid' | translate }}</mat-error>
        }
      </mat-form-field>

      <p class="ai-config__warning">
        <mat-icon class="ai-config__warning-icon">info_outline</mat-icon>
        <span>{{ 'organization_unit.ai_config.token_limit.scope' | translate }}</span>
      </p>

      <div class="ai-config__actions">
        <button mat-flat-button color="primary" type="button" [disabled]="!canSave" (click)="save()">
          {{ 'generic.save' | translate }}
        </button>
      </div>
    </div>

    <h4 class="ai-config__subtitle">{{ 'organization_unit.ai_config.quota.title' | translate }}</h4>

    @if (!usageQuotas.length) {
      <p class="ai-config__empty">{{ 'organization_unit.ai_config.quota.empty' | translate }}</p>
    } @else {
      <!-- A table cannot shrink below its content, so it gets its own scroll
           container rather than pushing the column wider than the tab. -->
      <div class="ai-config__table-scroll">
        <table class="ai-config__table">
        <thead>
          <tr>
            <th>{{ 'organization_unit.ai_config.quota.window' | translate }}</th>
            <th>{{ 'organization_unit.ai_config.quota.limit' | translate }}</th>
            <th>{{ 'organization_unit.ai_config.quota.used' | translate }}</th>
            <th>{{ 'organization_unit.ai_config.quota.requests' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (quota of usageQuotas; track trackByQuotaId($index, quota)) {
            <tr [class.ai-config__table-row--active]="quota.is_active">
              <td class="ai-config__table-period">
                {{ quota.start_date | i18n_date | async }} – {{ quota.end_date | i18n_date | async }}
                @if (quota.is_active) {
                  <span class="ai-config__active-badge">
                    {{ 'organization_unit.ai_config.quota.active' | translate }}
                  </span>
                }
              </td>
              <td>{{ quota.token_limit | i18n_number | async }}</td>
              <td>
                {{ quota.used_tokens | i18n_number | async }}
                <span class="ai-config__used-percentage">({{ usedPercentage(quota) }}%)</span>
              </td>
              <td>{{ quota.request_count | i18n_number | async }}</td>
            </tr>
          }
        </tbody>
        </table>
      </div>
    }
  }
</div>
